import Invoicing from "./pages/Features/Invoicing/Invoicing.js";
import ControlCenter from "./pages/Features/ControlCentre/controlcentre.js"
import MasterConfiguration from "./pages/Features/MasterConfiguration/MasterConfiguration.js";
import Broadcast from "./pages/Features/Broadcast/Broadcast";
import Reports from './pages/Features/Report/Report.jsx'
import CapacityTracker from "./pages/Features/CapacityTracker/CapacityTracker";
import ExamPlanning from "./pages/Features/ExamPlanning/ExamPlanning.js";
import Timesheet from "./pages/Features/Timesheet/Timesheet.js";
import ProjectHighlight from "./pages/Features/ProjectHighlight/ProjectHighlight.jsx";
import ProjectDetails from "./pages/Features/ProjectHighlight/ProjectDetails.jsx";
import ProjectReport from "./pages/Features/ProjectHighlight/ProjectReport.jsx";
import ProjectSprintWeek from "./pages/Features/ProjectHighlight/ProjectSprintWeek.jsx";
import ImportStatus from "./pages/Features/ImportStatus/ImportStatus.jsx";
import NoPermissionFound from "./components/NoPermissionFound/NoPermissionFound.js";
import SignUp from "./pages/Auth/SignUp/SignUp.js";
import Punctuality from "./pages/Features/Punctuality/Punctuality.jsx";
import GuestList from "./components/Gatepass/GuestList/GuestList.jsx";
import OutpassEntry from "./components/Gatepass/OutpassEntry/OutpassEntry.jsx";
import YearlyHolidayCalender from "./pages/Features/Calendar/YearlyHolidayCalender.jsx";
import HistoryData from "./pages/Features/HistoryData/HistoryData.jsx";
import GateKeeper from "./components/Gatepass/GateKeeperView/GatekeeperView.jsx";
import ImportData from "./pages/Features/ImportData/ImportData.jsx";
import CategoryWiseControlCenter from "./pages/Features/ControlCentre/CategoryWiseControlCenter.jsx";
import Dashboard from "./pages/Features/EmployeeDashboard/Dashboard.jsx";
import InspectraDashboard from "./pages/Features/Inspectra/InspectraDashboard.jsx";
import WelcomeKit from "./pages/Features/WelcomeKit/WelcomeKit.jsx";
import ProjectDashboard from "./pages/Features/ProjectDashboard/ProjectDashboard.jsx";
import DeviceDashboard from "./components/HelpDesk/DeviceDashboard.jsx";
import Events from "./pages/Features/Events/Events.jsx";
import KanbanBoard from "./pages/Features/KanbanBoard.js/KanbanBoard.jsx";
import PrecisionPulseReport from "./components/TeamOverview/Precision/PrecisionPulseReport.jsx";
import VpnRequestList from "./components/HelpDesk/VpnRequestList.jsx";
import JenkisRequestList from "./components/HelpDesk/JenkisRequestList.jsx";
import LogRequestList from "./components/HelpDesk/LogRequestList.jsx";
import ProjectAccessRequestList from "./components/HelpDesk/ProjectAccessRequestList.jsx";
import GitRequestList from "./components/HelpDesk/GitRequestList.jsx";
import LeadsDashboard from "./pages/Features/LeadDashboard/LeadsDashboard.jsx";
import EmployeeAttendanceInfo from "./components/LeadDashboard/EmployeeAttendanceInfo.jsx";
import ResourceRequestList from "./components/HelpDesk/ResourceRequestList.jsx";
import CabinBooking from "./pages/Features/CabinBooking/CabinBooking.jsx";
import ProdServerAccessList from "./components/HelpDesk/ProdServerAccessList.jsx";
import ManageAssets from "./pages/Features/ManageAssets/ManageAssets.jsx";
import AgileKanban from "./pages/Features/AgileKanban/AgileKanban.jsx";
import EmployeeFinanaceDetails from "./pages/Features/finance/EmployeeFinanaceDetails.jsx";
import CodeOfConduct from "./components/CodeOfConduct/CodeOfConduct.jsx";
import UniversalHelpdesk from "./pages/Features/HelpDesk/UniversalHelpdesk.jsx";
import CodeOfConductList from "./components/CodeOfConduct/CodeOfConductList.jsx";
import EvaluateList from "./pages/Features/EvaluateList/EvaluateList.jsx";
import TeamList from "./components/TeamOverview/TeamOverviewList/TeamList.jsx";
import IssueTypeHierarchyCRUD from "./pages/Features/Hierarchy/IssueTypeHierarchy.jsx";
import PrecisionEntry from "./pages/Features/PrecisionEntry/PrecisionEntry.jsx";
import ClientHighlight from "./pages/Features/ClientHighlight/ClientHighlight.jsx";
import ProdServiceBuildList from "./components/HelpDesk/ProdServiceBuildList.jsx";
import PrecisionDashboard from "./components/Report/PrecisionDashboard.jsx";
import ProjectTimesheetDetails from "./pages/Features/ProjectTimesheetDetails/ProjectTimesheetDetails.jsx";
import Regularization from "./pages/Features/Regularization/Regularization.jsx";
import Cipher from "./pages/Features/Cipher/Cipher.jsx";
import QuestionBank from "./pages/Features/QuestionBank/QuestionBank.jsx";
import Planning from "./pages/Features/Aglie/Planning/Planning.jsx";
import SurveyList from "./pages/Features/Survey/SurveyList.jsx";
import EstimateList from "./pages/Features/Aglie/Estimate/EstimateList.jsx";
import Declared from "./pages/Features/Aglie/Declaring/Declared.jsx";
import Review from "./pages/Features/Aglie/Review/Review.jsx";
import BucketConfigration from "./pages/Features/Aglie/Configration/BucketConfigration"
import GeneralSetting from "./pages/Features/GeneralSetting/GeneralSetting.jsx";
import ExperienceCenter from "./pages/Features/ExperienceCenter/ExperienceCenter.jsx";
import MyBucket from "./pages/Features/Aglie/MyBucket/MyBucket.jsx";
import ProjectHighLight from "./pages/Features/ProjectGlance/ProjectHighlight/ProjectHighLight.jsx";
import WelcomeKitList from "./pages/Features/WelcomeKitList/WelcomeKitList.jsx";
import ExtendRequestList from "./pages/Features/ExtendRequestList/ExtendRequestList.jsx";
import InventoryDashboard from "./pages/Features/InventoryDashboard/InventoryDashboard.jsx";
import TaskList from "./pages/Features/Tasks/TaskList.jsx";
import SurveyResponse from "./components/Survey/SurveyResponse.jsx";
import ServiceReport from "./pages/Features/serviceReport/ServiceReport.jsx";
import ProfileRequestList from "./components/Profile/ProfileRequestList.jsx";
import PrecisionMatrix from "./pages/Features/TalentMatrix/PrecisionMatrix.jsx";
import AgileMatrix from "./pages/Features/TalentMatrix/AgileMatrix.jsx";
import TimeMatrix from "./pages/Features/Aglie/TimeMatrix/TimeMatrix.jsx";
import ServerDatabase from "./components/ServerDatabase/ServerDatabase.jsx";
import Fields from "./pages/Features/TaskLayout/Fields.jsx";
import Screens from "./pages/Features/TaskLayout/Screens.jsx";
import Priorities from "./pages/Features/TaskLayout/Priorities.jsx";
import TaskTypeHierarchy from "./pages/Features/TaskLayout/TaskTypeHierarchy.jsx";
import TaskStatus from "./pages/Features/TaskLayout/TaskStatus.jsx";
import Awards from "./pages/Features/Awards/Awards.jsx";
// import DynamicDashboard from "./pages/Features/DynamicDashboard/DynamicDashboard.jsx";
import SurveyNodes from "./pages/Features/SurveyNodes/SurveyNodes.jsx";

export const route = [
    { path: '/employee-dashboard', name: 'Dashboard', element: Dashboard, exact: true },
    { path: "/lead-dashboard", name: "Lead Dashboard", element: LeadsDashboard },
    // { path: "/dynamic-dashboard", name: "Lead Dashboard", element: DynamicDashboard },
    { path: '/invoicing', name: 'Invoicing', element: Invoicing },
    { path: '/timesheet', name: 'Timesheet', element: Timesheet },
    { path: '/timesheet-summary', name: 'Timesheet', element: Timesheet },
    { path: '/timesheet-chart', name: 'Timesheet', element: Timesheet },
    { path: '/project-highlight', name: 'Project Highlight', element: ProjectHighlight },
    { path: "/project-highlight-dashboard", bame: "Project Dashboard", element: ProjectDashboard },
    { path: "/client-highlight", bame: "Project Dashboard", element: ClientHighlight },
    { path: '/caregory-control-center', name: 'ControlCenter', element: CategoryWiseControlCenter },
    { path: '/control-center', name: 'ControlCenter', element: ControlCenter },
    { path: '/master-configuration', name: 'Master Configuration', element: MasterConfiguration },
    { path: '/broadcast', name: 'Broadcast', element: Broadcast },
    { path: '/import-status', name: 'ImportStatus', element: ImportStatus },
    { path: '/holiday-calender', name: 'Holiday Calender', element: YearlyHolidayCalender },
    { path: '/static-report', name: 'Static Reports', element: Reports },
    { path: '/dynamic-report', name: 'Dynamic Reports', element: Reports },
    { path: '/project-details', name: 'Resource Data', element: ProjectDetails },
    { path: '/project-report', name: 'Resource Data', element: ProjectReport },
    { path: '/project-sprint-report', name: 'Sprint Planning', element: ProjectSprintWeek },
    { path: '/project-week-report', name: 'Sprint Planning', element: ProjectSprintWeek },
    { path: '/team-list', name: 'Team Overview', element: TeamList },
    { path: '/chart-config', name: 'Chart Config', element: TeamList },
    { path: '/capacity-tracker', name: 'Capacity Tracker', element: CapacityTracker },
    { path: '/exam-planning', name: 'Exam Planning', element: ExamPlanning },
    { path: '/help-desk-git', name: 'Help Desk', element: GitRequestList },
    { path: '/help-desk-vpn', name: 'Help Desk', element: VpnRequestList },
    { path: '/help-desk-prod-server', name: 'Help Desk', element: ProdServerAccessList },
    { path: '/help-desk-jenkins', name: 'Help Desk', element: JenkisRequestList },
    { path: '/help-desk-logs', name: 'Help Desk', element: LogRequestList },
    { path: '/help-desk-prod-build', name: 'Help Desk', element: ProdServiceBuildList },
    { path: '/device-dashboard', name: 'Device DashBoard', element: DeviceDashboard },
    { path: '/help-desk-project-access', name: 'Help Desk', element: ProjectAccessRequestList },
    { path: '/guest-list', name: 'Guest List', element: GuestList },
    { path: '/outpass-entry', name: 'Outpass entry', element: OutpassEntry },
    { path: '/gatekeeper', name: 'Gate Keeper', element: GateKeeper },
    { path: '/no-permission', name: 'No permission', element: NoPermissionFound },
    { path: '/sign-up', name: 'Sign Up', element: SignUp },
    { path: "/history", name: "History", element: HistoryData },
    { path: "/import-data", name: "Import Data", element: ImportData },
    { path: "/inspectra", name: "Inspectra", element: InspectraDashboard },
    { path: "/welcome-kit", name: "Welcome Kit", element: WelcomeKit },
    { path: "/events", name: "Events", element: Events },
    { path: "/precision", name: "Precision", element: PrecisionPulseReport },
    { path: "/kanban-Board", name: "Kanban Board", element: KanbanBoard },
    { path: "/agile-kanban", name: "Agile kanban", element: AgileKanban },
    { path: "/employee-attendance", name: "Employee Attendance", element: EmployeeAttendanceInfo },
    { path: "/punch-report", name: "Employee Attendance", element: EmployeeAttendanceInfo },
    { path: "/regularization-list", name: "Regularization Request", element: Regularization },
    { path: "/punctuality-report", name: "Punctuality", element: Punctuality },
    { path: "/resource-request", name: "Resource Request", element: ResourceRequestList },
    { path: "/employee-finanace", name: "Employee Finance", element: EmployeeFinanaceDetails },
    { path: "/cabin-booking", name: "Cabin Booking", element: CabinBooking },
    { path: "/manage-assets", name: "Manage Assets", element: ManageAssets },
    { path: "/inventory-dashboard", name: "Inventory Dashboard", element: InventoryDashboard },
    { path: "/universal-helpdesk", name: "Universal Heldesk", element: UniversalHelpdesk },
    { path: "/universal-helpdesk-chart", name: "Universal Heldesk", element: UniversalHelpdesk },
    { path: "/code-of-conduct", name: "Code Of Conduct", element: CodeOfConduct },
    { path: "/code-of-conduct-list", name: "Code Of Conduct List", element: CodeOfConductList },
    { path: "/evaluate-list", name: "Evaluate List", element: EvaluateList },
    { path: "/issue-type-hierarchy", name: "Issue type hierarchy", element: IssueTypeHierarchyCRUD },
    { path: "/precision-entry", name: "Precision Entry", element: PrecisionEntry },
    { path: "/precision-report", name: "Precision Dashboard", element: PrecisionDashboard },
    { path: "/project-timesheet-details", name: "Project Timesheet details", element: ProjectTimesheetDetails },
    { path: "/cipher", name: "Cipher", element: Cipher },
    { path: "/question-bank", name: "Question Bank", element: QuestionBank },
    { path: "/survey", name: "Survey", element: SurveyList },
    { path: "/survey-response", name: "Survey Response", element: SurveyResponse },
    { path: "/survey-evaluate-list", name: "Survey", element: EvaluateList },
    { path: "/nodes", name: "Nodes", element: SurveyNodes },
    { path: '/estimating', name: 'Estimate', element: EstimateList },
    { path: '/declaring', name: 'Declare', element: Declared },
    { path: "/planning", name: "Planning", element: Planning },
    { path: "/reviewing", name: "Review", element: Review },
    { path: "/my-bucket", name: "My Bucket", element: MyBucket },
    { path: "/bucket-configration", name: "Configration", element: BucketConfigration },
    { path: "/general-setting", name: "General Setting", element: GeneralSetting },
    { path: "/experience-center", name: "Experience Center", element: ExperienceCenter },
    { path: "/project-glance", name: "Project HighLight", element: ProjectHighLight },
    { path: "/welcome-kit-list", name: "Welcome Kit List", element: WelcomeKitList },
    { path: "/timesheet-request-list", name: "Time Sheet list", element: ExtendRequestList },
    { path: "/task-list", name: "Time Sheet list", element: TaskList },
    { path: "/service-desk-report", name: "Time Sheet list", element: ServiceReport },
    { path: "/profile-request", name: "Profile Request", element: ProfileRequestList },
    { path: "/precision-matrix", name: "Profile Request", element: PrecisionMatrix },
    { path: "/agile-matrix", name: "Profile Request", element: AgileMatrix },
    { path: "/time-matrix", name: "Profile Request", element: TimeMatrix },
    { path: "/server-db-master", name: "Server Access Config", element: ServerDatabase },
    { path: "/fields", name: "Task Layout", element: Fields },
    { path: "/screens", name: "Task Layout", element: Screens },
    { path: "/priorities", name: "Task Layout", element: Priorities },
    { path: "/task-type-hierarchy", name: "Task Layout", element: TaskTypeHierarchy },
    { path: "/task-status", name: "Task Layout", element: TaskStatus },
    { path: "/awards", name: "Awards", element: Awards },
]